import PropTypes from 'prop-types';

const componentDetail = {
  label: 'Payment Amount Input - Standard',
  value: 'AmountInput',
};
const builderConfig = {
  general: {
    label: {
      type: 'string',
      required: true,
      max: { max: 30, message: `Max length is 30` },
    },
    hint: {
      type: 'string',
      required: false,
      max: { max: 60, message: `Max length is 60` },
    },
  },
};

const propTypes = {
  label: PropTypes.string.isRequired,
  hint: PropTypes.string.isRequired,
  input: PropTypes.object,
};

const defaultProps = {
  label: 'Label',
  hint: window.isBizCentral ? 'Hint' : '',
};

export default { componentDetail, builderConfig, propTypes, defaultProps };
